import React, { useMemo } from 'react';
import InputVertical from './InputVertical';
import { getLabelCharacters } from '../utils';
var InputVerticalDynamicLabel = function (_a) {
    var name = _a.name, type = _a.type, value = _a.value, isRequired = _a.isRequired, valid = _a.valid, invalid = _a.invalid, disabled = _a.disabled, feedback = _a.feedback, onChange = _a.onChange, className = _a.className, placeholder = _a.placeholder, min = _a.min, max = _a.max, step = _a.step, autoFocus = _a.autoFocus, autoComplete = _a.autoComplete, inputClassName = _a.inputClassName, onFocus = _a.onFocus, onBlur = _a.onBlur, size = _a.size, isRounded = _a.isRounded, helpText = _a.helpText, onKeyDown = _a.onKeyDown, id = _a.id, isSearchInput = _a.isSearchInput, onClearValue = _a.onClearValue, labelStart = _a.labelStart, labelEnd = _a.labelEnd;
    var renderContent = useMemo(function () {
        return (React.createElement(InputVertical, { label: getLabelCharacters(labelStart, labelEnd ? labelEnd : ')', value, max), name: name, type: type, value: value, isRequired: isRequired, valid: valid, invalid: invalid, disabled: disabled, feedback: feedback, className: className, placeholder: placeholder, min: min, max: max, step: step, autoFocus: autoFocus, autoComplete: autoComplete, inputClassName: inputClassName, onFocus: onFocus, onBlur: onBlur, size: size, isRounded: isRounded, helpText: helpText, onKeyDown: onKeyDown, id: id, isSearchInput: isSearchInput, onClearValue: onClearValue, onChange: function (value) {
                if (value.length <= max) {
                    onChange(value);
                }
            } }));
    }, [
        autoComplete,
        autoFocus,
        className,
        disabled,
        feedback,
        helpText,
        id,
        inputClassName,
        invalid,
        isRequired,
        isRounded,
        isSearchInput,
        labelEnd,
        labelStart,
        max,
        min,
        name,
        onBlur,
        onChange,
        onClearValue,
        onFocus,
        onKeyDown,
        placeholder,
        size,
        step,
        type,
        valid,
        value,
    ]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { InputVerticalDynamicLabel };
//# sourceMappingURL=InputVerticalDynamicLabel.js.map